"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/textfield/dist/mdc.textfield.css");
require("@rmwc/floating-label/styles");
require("@rmwc/notched-outline/styles");
require("@rmwc/line-ripple/styles");
require("@rmwc/ripple/styles");
require("@rmwc/icon/styles");
